// import Vue from "vue";
// import Vuex from "vuex";
import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import sls from "./storage";
import Cookies from "js-cookie";
import router from "@/router";
// AUTH
import { fetchUserAttributes, fetchAuthSession, signOut } from "@aws-amplify/auth";
import { getEmployeesList, getUser } from "@/services/user.service";
// MODULE STORES
import siteTrackAuth from '../../Site-Track/store/siteTrackAuth';
import siteTrackNav from "../../Site-Track/store/siteTrackNav";
import siteTrackPreventative from '../../Site-Track/store/siteTrackPreventative';
import siteTrackCorrective from '../../Site-Track/store/siteTrackCorrective';
import siteTrackIncident from '../../Site-Track/store/siteTrackIncident';
import siteTrackInventory from '../../Site-Track/store/siteTrackInventory';
import siteTrackPurchaseOrders from '../../Site-Track/store/siteTrackPurchaseOrders';
import siteTrackAssets from '../../Site-Track/store/siteTrackAssets';
import siteTrackAlerts from "../../Site-Track/store/siteTrackAlerts";
import siteTrackManager from "../../Site-Track/store/siteTrackManager";
import siteCommandNav from "../../Site-Command/store/siteCommandNav";
import siteCommandMaintenanceMode from "../../Site-Command/store/siteCommandMaintenanceMode";
import siteCommandConfig from "../../Site-Command/store/siteCommandConfig";
import siteCommandOutputs from '../../Site-Command/store/siteCommandOutputs';
import siteCommandOverrides from '../../Site-Command/store/siteCommandOverrides';
import siteCommandInputs from '../../Site-Command/store/siteCommandInputs';
import siteCommandWash from '../../Site-Command/store/siteCommandWash';
import siteCommandUpsells from '../../Site-Command/store/siteCommandUpsells';
import siteCommandAssets from '../../Site-Command/store/siteCommandAssets';
import assetCodeGraph from '../../Site-Command/store/assetCodeGraph';
import configurationUsers from "../../Configuration/store/configurationUsers"
import siteScanNav from "../../Site-Scan/store/siteScanNav";
import siteScanStore from "../../Site-Scan/store/siteScan.store";
import siteUniteNav from "../../Site-Unite/store/siteUniteNav"
import reportsNav from "../../Reports/store/reportsNav"
import configurationNav from "../../Configuration/store/configurationNav"
import administrationNav from "../../Administration/store/administrationNav"
// SHARED
import sharedModal from './sharedModal';
import sharedMobileMenu from './sharedMobileMenu';
import sideMenuNotifications from './sideMenuNotifications';
import sharedFilters from './sharedFilters';
import sharedPrompt from './sharedPrompt';
import alerts from './alerts';
import socket from './socket';
import announcements from './announcements';
import chat from './chat';
import table from './table';

const getDomain = () => {
  const hostname = window.location.hostname; // e.g., "staging.cruzcontrol.app"
  return hostname;
};

const userCookie = createPersistedState({
  key: 'cruzcontrol',
  paths:["user"],
  storage: {
    getItem: (key) => {
      return Cookies.get(key);
    },
    // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
    setItem: (key, value) =>
        Cookies.set(key, value, {
          expires: 365,
          domain: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? undefined : '.cruzcontrol.app',
          secure: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? false : true
        }),
    removeItem: key => Cookies.remove(key)
  }
})

const themeCookie = createPersistedState({
  key: 'cruzcontrolTheme',
  paths:["theme"],
  storage: {
    getItem: (key) => {
      return Cookies.get(key);
    },
    // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
    setItem: (key, value) =>
        Cookies.set(key, value, {
          expires: 365,
          domain: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? undefined : '.cruzcontrol.app',
          secure: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? false : true
        }),
    removeItem: key => Cookies.remove(key)
  }
})

const siteCookie = createPersistedState({
  key: 'cruzcontrolSite',
  paths:["active_site", "sessionTimestamp"],
  storage: {
    getItem: (key) => {
      const data = sls.get(key)
      if (!data) return null
      return data
    },
    setItem: (key, value) => {
      sls.set(key, value)
    },
    removeItem: key => sls.remove(key)
  }
})


//moved this out of cookie state since its local to the tenant only. "user" is something that has to be used across multiple sites. We could probably
//deprecate the object and used strictly cognito data.. but I don't wanna do all that right now.
//using secure-ls to obfuscate localstorage data. its Base64 but can be changed to something like AES.
const localDataStorage = createPersistedState({
  key: 'cruzcontrolPermissions',
  //Added permission_set for now until we refactor the system and call it continuously per nav function. this should stop 404's for the time being on refresh.
  paths:["permissionSet", 'availableModules', 'userPermissions', 'tenantSuperUser', 'isAdmin', 'userManagement', 'sharedPrompt.doNotShowAgainVal'],
  storage: {
    getItem: (key) => {
      return sls.get(key);
    },
    setItem: (key, value) =>
        sls.set(key, value, {
          expires: 365,
          domain: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? undefined : getDomain(),
          secure: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? false : true
        }),
    removeItem: key => sls.remove(key)
  }
})


// const permissionsCookie = createPersistedState({
//   key: 'permissions',
//   paths:["", "availableModules", "getAvailableViews"],
//   storage: {
//     getItem: (key) => {
//       return Cookies.get(key);
//     },
//     // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
//     setItem: (key, value) =>
//         Cookies.set(key, value, { expires: 365, domain: '.cruzcontrol.app', secure: true }),
//     removeItem: key => Cookies.remove(key)
//   }
// })

/*const localData = createPersistedState({
  key: 'cruzcontrol',
  paths:["active_site", "employee_sites", "permissionSet", "headers"],
  storage: window.localStorage,
})*/ 

// const store = Vuex.createStore({
const store = createStore({
  modules: {
    siteTrackNav,
    siteTrackAuth,
    siteTrackPreventative,
    siteTrackCorrective,
    siteTrackIncident,
    siteTrackInventory,
    siteTrackPurchaseOrders,
    siteTrackAssets,
    siteTrackAlerts,
    siteTrackManager,
    siteCommandNav,
    siteCommandMaintenanceMode,
    siteCommandConfig,
    siteCommandOutputs,
    siteCommandOverrides,
    siteCommandInputs,
    siteCommandWash,
    siteCommandUpsells,
    siteCommandAssets,
    assetCodeGraph,
    configurationUsers,
    siteScanNav,
    siteScanStore,
    siteUniteNav,
    reportsNav,
    configurationNav,
    administrationNav,
    sharedModal,
    sharedMobileMenu,
    sideMenuNotifications,
    sharedFilters,
    sharedPrompt,
    alerts,
    socket,
    announcements,
    chat,
    table,
    // UtilityStore
  },
  plugins: [userCookie, themeCookie, siteCookie, localDataStorage],
  state: {
    user: {
      id: null,
      email: null,
      firstname: null,
      lastname: null,
      active_tenant_id: null,
    },
    active_site: null,
    noSiteAccess: false,
    canScrollOnBody: true,
    sideMenuVisible: false,
    mobileSideMenuVisible: false,
    mainMenuCollapsed: false,
    sectionMenuCollapsed: false,
    refreshed: false,
    refreshedItem: null,
    headers: {
      'Content-Type' : 'application/json',
      'sessionId': null,
      'tenantId': null,
      'siteId': null,
      'siteCommandId': null,
      'siteEmployeeId': null
    },
    accessToken: null,
    idToken: null,
    sessionTimestamp: null,
    screen: {
      'sm': false,
      'md': false,
      'lg': false,
      'xl': false,
      '2xl': false
    },
    orientation: {
      'portrait': false,
      'landscape': false
    },
    lastNavWasPop: false,
    lastPopNavigationPosition: null,
    scrollTop: 0,
    routeBeforeForcedLogout: null,
    employee_sites: [],
    /**
     * @TODO We use this to determine if they have a POS system, and what kind it is.
     * This might change in time, but its a starting point.
     */
    pos_system: "",
    permissionSet: {
      receive_email: false,
      receive_sms: false,
      alerts_read: false,
      reports_read: false,
      reports_write: false,
      site_command_read: false,
      site_command_write: false,
      site_drive_read: false,
      site_drive_write: false,
      site_scan_read: false,
      site_scan_write: false,
      site_track_read: false,
      site_track_write: false,
      site_unite_read: false,
      site_unite_write: false,
      manager_tools: false,
      permission_role: "Employee",
      is_chemical_only: false,
    },
    userPermissions: {},
    permissionSets: [],
    availableModules: [],
    availableViews: {},
    availableSubnavs: {},
    tenantSuperUser: false,
    isAdmin: false,
    userManagement: false,
    network_devices: [],
    cradlepoint_router: "",
    QRCode: "",
    initError: null,
    loadedValues: {
      preloadData: false,
      employee_sites: false,
      assets: false,
      models: false,
      locations: false,
      suppliers: false,
      permissionSets: false
    },
    userObj: {},
    userAvatar: null,
    reroutePrevented: false,
    reroutePrompt: [],
    toPath: null,
    copied: null,
    priorityOptions: [
      {
        id: "low",
        name: "Low",
        dropdownAppend: {
          position: "left",
          component: "PriorityChip",
          props: { priority: "low" }
        }
      },
      {
        id: "medium",
        name: "Medium",
        dropdownAppend: {
          position: "left",
          component: "PriorityChip",
          props: { priority: "medium" }
        }
      },
      {
        id: "critical",
        name: "Critical",
        dropdownAppend: {
          position: "left",
          component: "PriorityChip",
          props: { priority: "critical" }
        }
      }
    ],
    sites: [],
    regions: [],
    globalRegion: {
      id: "e7303baf-81ef-4835-8bd8-6b3a61a49f4a",
      child_sites: [],
      child_regions: [],
    },
    theme: null,
  },
  getters: {
    mobileSideMenuOpen: state => state.mobileSideMenuVisible,
    mainMenuCollapsed: state => state.mainMenuCollapsed,
    sectionMenuCollapsed: state => state.sectionMenuCollapsed,
    getUser: (state) => state.user,
    getEmail: (state) => state.user.email,
    getUserId: (state) => state.user.id,
    getFullName: (state) => `${state.user.firstname} ${state.user.lastname}`,
    getActiveTenantId: (state) => state.user.active_tenant_id,
    getActiveSite: state => state.active_site,
    getSiteId: state => state.active_site?.site_id,
    getHeadersSiteId: state => state.headers.siteId,
    getHeadersSiteEmployeeId: state => state.headers.siteEmployeeId,
    getEmployeeSites: state => state.employee_sites,
    getSitesObj: state => {
      let obj = {}
      for (let site of state.employee_sites) {
        obj[site.site_id] = site
      }
      return obj
    },
    getPermissionSet: state => state.permissionSet,
    getPermissionSetRole: state => state.permissionSet.permission_role,
    getAllPermissionSets: state => state.permissionSets,
    getNonHiddenPermissionSets: state => state.permissionSets.filter(x => !x.hidden),
    getHiddenPermissionSets: state => state.permissionSets
      .filter(x => x.hidden)
      .map(x => ({
        ...x,
        dropdownAppend: {
          position: "right",
          icon: "fa-solid fa-shield-halved",
          classes: "text-secondary dark:text-secondary-200"
        }
      })
    ),
    getPermissionSetsObj: state => {
      let obj = {}
      for (let set of state.permissionSets) {
        obj[set.id] = set
      }
      return obj
    },
    getHiddenPermissionSetsObj: state => {
      let obj = {}
      for (let set of state.permissionSets) {
        if (set.hidden) obj[set.id] = set
      }
      return obj
    },
    getUserPermissions: state => state.userPermissions,
    getAvailableModules: state => state.availableModules,
    getAvailableFeatures: (state, getters) => {
      let obj = {}
      // get nav items for each module
      let moduleNavs = {
        "site_track": getters.siteTrackNav,
        "site_command": getters.siteCommandNav,
        "site_scan": getters.siteScanNav,
        "site_unite": getters.siteUniteNav,
        "reports": getters.reportsNav,
        "configuration": getters.configurationNav,
        "administration": getters.administrationNav
      }
      // iterate through available user modules
      for (let moduleName of Object.keys(state.userPermissions)) {
        // each module will contain an object with bools for each feature
        obj[moduleName] = {}
        // avoid error if no matching nav item for module
        if (!moduleNavs[moduleName]) continue
        // iterate through nav objects for said module
        for (let option of Object.values(moduleNavs[moduleName])) {
          if (option.feature == null && option.subnav) {
            // if option has subnav, check if any subnav options are available
            for (let subOption of option.subnav) {
              if (!obj[moduleName][subOption.feature]) obj[moduleName][subOption.feature] = false
              if (!state.userPermissions[moduleName][subOption.feature]) continue
              obj[moduleName][subOption.feature] = Object.values(state.userPermissions[moduleName][subOption.feature])[0]?.main_view?.object?.read_bool
            }
            continue
          }
          // every feature is set to false by default
          if (!obj[moduleName][option.feature]) obj[moduleName][option.feature] = false
          if (!state.userPermissions[moduleName][option.feature]) continue
          // if no subnav, check to see if only "main_view" object has its "read_bool" value set to true 
          if (!option.subnav) {
            obj[moduleName][option.feature] = Object.values(state.userPermissions[moduleName][option.feature])[0]?.main_view?.object?.read_bool
          }
          else {
            let hasReadPermissions = false
            for (let view of Object.values(state.userPermissions[moduleName][option.feature])) {
              if (view.main_view?.object?.read_bool === true) {
                hasReadPermissions = true
              }
            }
            obj[moduleName][option.feature] = hasReadPermissions
          }
        }
      }

      return obj
    },
    getAvailableViews: (state, getters) => {
      let obj = {}
      // get nav items for each module
      let moduleNavs = {
        "site_track": getters.siteTrackNav,
        "site_command": getters.siteCommandNav,
        "site_scan": getters.siteScanNav,
        "site_unite": getters.siteUniteNav,
        "reports": getters.reportsNav,
        "configuration": getters.configurationNav,
        "administration": getters.administrationNav
      }
      // iterate through available user modules
      for (let moduleName of Object.keys(state.userPermissions)) {
        // each module will contain an object with bools for each feature
        obj[moduleName] = {}
        // avoid error if no matching nav item for module
        if (!moduleNavs[moduleName]) continue
        // iterate through nav objects for said module
        for (let option of Object.values(moduleNavs[moduleName])) {

          // need to go one level deeper if within a subnav (like reports)
          if (option.module) {
            for (let suboption of option.subnav) {
              if (!state.userPermissions[moduleName][suboption.feature]) continue
              // if no subnav, check to see if only "main_view" object has its "read_bool" value set to true
              if (suboption.subnav) {
                // every feature is has its own subobject
                if (!obj[moduleName][suboption.feature]) obj[moduleName][suboption.feature] = {}
                for (let [viewName, view] of Object.entries(state.userPermissions[moduleName][suboption.feature])) {
                  obj[moduleName][suboption.feature][viewName] = false
                  // check if any subnav suboptions has its main_view set to true
                  if (view.main_view.object?.read_bool) {
                    obj[moduleName][suboption.feature][viewName] = true
                  }
                }
              }
            }
          }

          if (!state.userPermissions[moduleName][option.feature]) continue
          // if no subnav, check to see if only "main_view" object has its "read_bool" value set to true 
          if (option.subnav) {
            // every feature is has its own subobject
            if (!obj[moduleName][option.feature]) obj[moduleName][option.feature] = {}
            for (let [viewName, view] of Object.entries(state.userPermissions[moduleName][option.feature])) {
              obj[moduleName][option.feature][viewName] = false
              // check if any subnav options has its main_view set to true
              if (view.main_view.object?.read_bool) {
                obj[moduleName][option.feature][viewName] = true
              }
            }
          }
        }
      }
      return obj
    },
    getIsTenantSuperuser: state => state.tenantSuperUser,
    // getIsTenantSuperuser: () => false,
    getIsAdmin: state => state.isAdmin,
    getUserManagementAccess: state => state.userManagement,
    getIsManager: state => state.permissionSet.manager_tools,
    getIsHR: state => state.permissionSet.is_manager,
    getNetworkDevices: state => state.network_devices,
    getCradlePointRouter: state => state.router,
    getScreenSize: state => state.screen,
    getScrollTop: state => state.scrollTop,
    getQRCode: state => state.QRCode,
    getInitError: state => state.initError,
    loadedGlobalValues: state => state.loadedValues,
    getUserObject: state => state.userObj,
    getUserAvatar: state => state.userAvatar,
    getPOSSystem: state => state.pos_system,
    isReroutePrevented: state => state.reroutePrevented,
    getReroutePrompt: state => state.reroutePrompt,
    getToPath: state => state.toPath,
    getCopiedData: state => state.copied,
    getTheme: state => state.theme,
    priorityOptionsWithAll(state) {
      return [
        {
          id: "",
          name: "All",
          dropdownAppend: {
            position: "left",
            component: "PriorityChip",
            props: { priority: "all" },
            showOnlyInDropdown: true
          }
        },
        ...state.priorityOptions
      ]
    },
    getSitesByRegion(state) {
      return state.regions
    },
    getGlobalRegion(state) {
      return state.globalRegion
    },
    getRegionsObj(state) {
      const obj = {}
    
      function collectRegions(regions) {
        for (const region of regions) {
          if (region.id) {
            obj[region.id] = region
          }
          if (Array.isArray(region.child_regions) && region.child_regions.length > 0) {
            collectRegions(region.child_regions)
          }
        }
      }
    
      collectRegions([state.globalRegion])
    
      return obj
    },      
    getSiteToRegion(state) {
      const map = {}
    
      const traverse = (region, path = []) => {
        const currentPath = [...path, region.id]
    
        // Assign path to all sites in this region
        if (Array.isArray(region.child_sites)) {
          for (const site of region.child_sites) {
            map[site.id] = currentPath
          }
        }
    
        // Recurse through subregions
        if (Array.isArray(region.child_regions)) {
          for (const subregion of region.child_regions) {
            traverse(subregion, currentPath)
          }
        }
      }
    
      // for (const region of state.regions) {
      //   traverse(region, [])
      // }
      traverse(state.globalRegion, [])
    
      return map
    },
    isDarkTheme(state) {
      return state.theme == "dark"
    }         
  },
  mutations: {
    TOGGLE_SIDEMENU: (state) => {
      state.sideMenuVisible = !state.sideMenuVisible
      if (state.sideMenuVisible) state.canScrollOnBody = false
      else state.canScrollOnBody = true
    },
    TOGGLE_MOBILEMENU: (state) => {
      state.mobileSideMenuVisible = !state.mobileSideMenuVisible
      if (state.mobileSideMenuVisible) state.canScrollOnBody = false
      else state.canScrollOnBody = true
    },
    CLOSE_MOBILEMENU(state) {
      state.mobileSideMenuVisible = false
      state.canScrollOnBody = true
    },
    DISABLE_BODY_SCROLL: (state) => {
      state.canScrollOnBody = !state.canScrollOnBody
    },
    SELECT_SITE: (state, newSite) =>{
      state.active_site = newSite;
      state.headers.siteId = newSite?.site_id;
      state.headers.siteEmployeeId = newSite?.id;
    },
    setActiveSite(state, newSite) {
      state.active_site = newSite;
      state.headers.siteId = newSite?.site_id;
      state.headers.siteEmployeeId = newSite?.id;
    },
    setNoSiteAccess(state, bool) {
      state.noSiteAccess = bool;
      if (bool) {
        state.active_site = null;
        state.headers.siteId = null;
        state.headers.siteEmployeeId = null;
      }
    },
    collapseMainMenu(state, bool) {
      state.mainMenuCollapsed = bool
    },
    collapseSectionMenu(state, bool) {
      state.sectionMenuCollapsed = bool
    },
    refreshData(state, bool) {
      state.refreshed = bool
    },
    refreshItem(state, obj) {
      state.refreshedItem = obj
      console.log(state.refreshedItem)
    },
    setCurrentSessionData(state, data) {
      if (data.accesstoken) {
        state.accessToken = data.accesstoken;
      }
      if (data.idtoken) {
        state.idToken = data.idtoken;
      }
      state.sessionTimestamp = new Date();

      // const decodedToken = jwtDecode(state.accessToken);
      // // console.log("Decoded Token:", decodedToken);
      // const expirationTimestamp = decodedToken.exp;
      // const expirationDate = new Date(expirationTimestamp * 1000);
      // state.sessionExpiration = expirationDate;
  
      // console.table([{"Last activity on:": state.sessionTimestamp, "Token expires on:": expirationDate}]);
    },
    setSessionTimestamp(state, timestamp) {
      console.log("Setting session timestamp:", timestamp)
      state.sessionTimestamp = timestamp;
    },
    setSessionID(state, id) {
      state.headers.sessionId = id
    },
    // setEmployeeId(state, id){
    //   state.headers.siteEmployeeId = id;
    // },
    // setSiteId(state, id){
    //   state.headers.siteId = id;
    // },
    setEmployeeSites(state, newSitesList) {
      const seen = new Set()
      state.employee_sites = (newSitesList || []).filter(site => {
        if (seen.has(site.id)) return false
        seen.add(site.id)
        return true
      })
      state.loadedValues.employee_sites = true
    },
    setRegions(state, regions) {
      state.regions = regions
    },
    setGlobalRegion(state, region) {
      state.globalRegion = region
    },
    setPermissionSet(state, set) {
      state.permissionSet = set;
    },
    setEmployeePermissions(state, object) {
      state.userPermissions = object

      // insert user management permissions from tenant
      if (state.userManagement) {
        state.userPermissions.configuration.user_management = {
          users: {
            main_view: { object: {read_bool: true }},
          },
          permissions: {
            main_view: { object: {read_bool: true }},
          },
        }
      }
    },
    setAllPermissionSets(state, sets) {
      state.permissionSets = sets
      state.loadedValues.permissionSets = true
    },
    setAvailableModules(state, arr) {
      state.availableModules = arr
    },
    setPOS_System(state, pos_system) {
      state.pos_system = pos_system;
    },
    setScreenSize(state, width) {
      state.screen.sm = width >= 640
      state.screen.md = width >= 768
      state.screen.lg = width >= 1024
      state.screen.xl = width >= 1280
      state.screen['2xl'] = width >= 1536
    },
    setOrientation(state, bool) {
      state.orientation.portrait = !bool
      state.orientation.landscape = bool
    },
    setLastPopNavigationPosition(state, position) {
      state.lastPopNavigationPosition = position;
    },
    setScrollTop(state, num) {
      state.scrollTop = num
    },
    setRouteBeforeForcedLogout(state, route) {
      state.routeBeforeForcedLogout = route
    },
    setNetworkDevices(state, deviceArray) {
      state.network_devices = deviceArray
    },
    setCradlepointRouter(state, routerId) {
      state.cradlepoint_router = routerId
    },
    setQRCode(state, newQRCode) {
      state.QRCode = newQRCode
    },
    setInitError(state, error) {
      state.initError = error
    },
    setValueLoaded(state, name) {
      state.loadedValues[name] = true
    },
    setUser(state, user) {
      console.log("set User", user)
      state.user = user
    },
    setUserObject(state, obj) {
      state.userObj = obj
    },
    setUserTenantAccess(state, obj) {
      state.userManagement = obj.user_management
      state.tenantSuperUser = obj.is_tenant_superuser
      state.isAdmin = obj.is_admin
    },
    resetFromPortalBool(state) {
      state.user.from_portal = false
    },
    setUserAvatar(state, obj) {
      state.userAvatar = obj
    },
    preventReroute(state, bool) {
      state.reroutePrevented = bool
    },
    setReroutePrompt(state, arr) {
      state.reroutePrompt = arr
    },
    setToPath(state, path) {
      state.toPath = path
    },
    setCopiedData(state, data) {
      state.copied = data
    },
    setTheme(state, theme) {
      state.theme = theme
      document.documentElement.setAttribute('data-theme', theme)
    }
  },
  actions: {
    async init ({ commit }) {
      // This init function is ran on the router each time.  It checks for a few states and then if they are missing creates them.
      try {
        if (this.state.active_site == null || this.state.headers.siteId == null) {
          let cognitoData;
          // Check with Cognito to get our Current user via Cognito Cookies
          try {
            cognitoData = await fetchUserAttributes();
          } catch (error) {
            console.error("Error fetching user:", error);
            return null;
          }
          // Check with Portal API to get our real user
          let user
          await getUser(cognitoData.email)
          .then(response => {
            if (response.status == 200 && Array.isArray(response.data) && response.data.length > 0) {
              user = response.data[0]
            }
            else {
              console.error(response)
              commit("setPrompt", ["Unable to verify user information from server.", "closePrompt", null, { header: "Error" }])
              commit("setCognitoError", true)
              return
            }
          })
          console.log(user)
          // Verify we are who we say we are as a client.
          //console.log("Userid matches state user id")
          //Load Employee list from Portal. Employee is a 1:1 user to site representation
          let myEmployees = (await getEmployeesList(user.id))?.data?.results || [];
          // If state.active_site is null, set defaults.
          // console.log("Logging employee list from init function")
          // console.log(myEmployees[0])
          if(myEmployees[0]) {
            if (this.getActiveSite === null) {
              console.log("set active site from init")
              commit('setActiveSite', myEmployees[0]);
              commit('setPermissionSet', myEmployees[0].permissions);
              // commit('setEmployeeId', myEmployees[0].id);
              // commit('setSiteId', myEmployees[0].site_id);
            }
            // set a global state for employee sites.
            commit('setEmployeeSites', myEmployees);
            //Log out a bunch of datas
            //console.log("Logging employee sites")
            //console.log(this.getEmployeeSites)
          }
        }
      } catch (e) {
        console.log("ERROR")
        console.log(e)
        commit('setInitError', e)
      }
    },
    /**
     * Forces a token refresh via AWS Amplify and commits the new tokens.
     * Returns the new ID token string for use by external services (like Socket.io).
     */
    async refreshUserTokens({ commit }) {
      try {
        // Passing { forceRefresh: true } ensures Amplify doesn't just hand back 
        // the cached tokens, guaranteeing we get a fresh JWT for the socket.
        const { tokens } = await fetchAuthSession({ forceRefresh: true });
        if (!tokens) throw new Error("No tokens found in session");

        const { idToken, accessToken } = tokens;
        const sessionData = {
          'accesstoken': accessToken.toString(),
          'idtoken': idToken.toString()
        }

        commit("setCurrentSessionData", sessionData);
        
        // Return just the ID token so the caller (our socket error handler) can inject it
        return sessionData.idtoken; 
      } catch (error) {
        console.error("[Vuex] Token refresh failed:", error);
        throw error; // Let the caller handle the fallback (like forceLogout)
      }
    },
    /**
     * Centralized logout logic. Clears state, storage, and redirects appropriately.
     */
    async forceLogout({ commit }) {
      console.log("[Vuex] Executing force logout sequence.");
      // debugger
      
      // 1. Clear Vuex State
      commit("LogOutAT");
      commit("setSessionTimestamp", null);
      commit("setActiveSite", null);

      // 2. Handle environment-specific routing and cleanup
      if (import.meta.env.VITE_DEV_NETWORK_ACCESS === "true") {
        try {
          await signOut();
          Cookies.remove("cruzcontrol");
          Cookies.remove("cruzcontrolSite");
          sls.remove("cruzcontrolSite");
          router.push("/dev-login");
        } catch (error) {
          console.error('Error signing out of Cognito: ', error);
        }
      } else {
        Cookies.remove("cruzcontrol");
        Cookies.remove("cruzcontrolSite");
        sls.remove("cruzcontrolSite");
        window.location.href = 'https://portal.cruzcontrol.app/inactivity';
      }
    },
    async handleAuthError({ state, dispatch }) {
      console.log("[Vuex] Auth error.");
      // debugger
      if (state.sessionTimestamp == null) return
      const timeSinceLastActivity = new Date() - new Date(state.sessionTimestamp)
      const ONE_HOUR = 3600000

      if (timeSinceLastActivity < ONE_HOUR) {
        console.log("Socket auth failed, but activity is recent. Attempting refresh...")
        try {
          const newToken = await dispatch('refreshUserTokens')
          updateSocketToken(newToken)
          // Let the socket's auto-reconnect take over now that the token is updated
        } catch (error) {
          console.log("Unable to refresh token")
          // debugger
          // dispatch('forceLogout')
        }
      } else {
        console.log("Socket auth failed and inactivity timeout exceeded.")
        // debugger
        dispatch('forceLogout')
      }
    }
  }
})

export default store;
